<template>
  <li class="edit-item flex-left">
    <div class="edit-item-left flex-row" v-handle>
      <i class="iconfont icon-moreandroid"></i>
    </div>
    <div class="edit-item-right w-100">
      <div class="flex-left w-100 edit-text-wrap" :class="textErrorClass">
        <div class="input-wrap">
          <editable-input placeholder="*Text" class="edit-text"
                          v-model.trim="value.text" @change="handleChange"></editable-input>
        </div>
        <i class="iconfont disable-icon"
           :class="stateClass"
           @click="handleToggleIcon()">
        </i>

      </div>
      <span v-if="hasTextError" class="flex-left w-100 error-msg">{{textErr}}</span>
      <div class="flex-left w-100 edit-url-wrap" :class="UrlErrorClass">
        <div class="input-wrap">
          <editable-input v-if="!isVCard"
                          placeholder="Url"
                          class="edit-url"
                          default-prefix="http://www."
                          v-model.trim="value.url" @change="handleUrlChange($event)"></editable-input>
        </div>
      </div>
      <span v-if="hasUrlError" class="flex-left w-100 error-msg">{{urlErr}}</span>

      <div class="flex-row w-100">
        <i class="iconfont icon-image-add"
           :style="imageSelectStyle"
           :class="imageIconClass"
           @click="handleImgPopup(value)"></i>
        <i class="iconfont icon-delete-bin" @click="deleteLink(value)"></i>
      </div>
    </div>
  </li>
</template>

<script>
import {ElementMixin, HandleDirective} from 'vue-slicksort';
import editableInput from "../component/editableInput.vue";
import adminService from "../service/adminService";
import {validateError} from "../../common/utils/errors";
import toast from "../../common/utils/toast";

export const IMAGE_POPUP_EVENT = 'open';
export const ITEM_CHANGE_EVENT = 'change';
export const ITEM_REMOVED_EVENT = 'removed';

export default {
  name: "block",
  mixins: [ElementMixin],
  directives: {handle: HandleDirective},
  props: {
    item: {
      type: Object,
      default() {
        return {
          block_id: '',
          icons: '',
          image: '',
          position: '',
          state: '',
          text: '',
          url: '',
        }
      }
    }
  },
  components: {
    'editable-input': editableInput,
  },

  data() {
    return {
      value: {
        block_id: '',
        icons: '',
        image: '',
        position: '',
        state: '',
        text: '',
        url: '',
      },
      urlErr:'',
      hasUrlError: false,
      hasTextError: false,
      textErr:'',
    }
  },

  mounted() {
    this.value = this.item;
  },

  computed: {
    UrlErrorClass() {
      return this.hasUrlError ? "error-item" : "";
    },
    stateClass() {
      return this.value.state ? ' icon-toggle-on' : ' icon-toggle-off'
    },
    imageIconClass() {
      if (this.value.image && this.value.image.length > 0) {
        return '';
      }
      if (this.value.icons && this.value.icons.length > 0) {
        return '';
      }
      return 'icon-color';
    },
    isVCard() {
      return this.value.type === 2;
    },
    imageSelectStyle() {
      if (this.isVCard) {
        return {
          visibility: "hidden"
        };
      }
      return {};
    },
    textErrorClass() {
      return this.hasTextError ? "error-item" : "";
    },
  },

  methods: {
    /**
     * 删除 block
     */
    deleteLink(item) {
      if (!confirm('Are you sure?')) {
        return;
      }
      adminService.removeBlock(item.block_id)
          .then((res) => {
            console.log(res);
            this.$emit(ITEM_REMOVED_EVENT, item);
          })
          .catch((error) => {
            debugger;
            console.log(error);
          })
    },

    /**
     * 控制link的显隐
     */

    handleToggleIcon() {
      this.value.state = this.value.state > 0 ? 0 : 1;
      this.handleEditBlock(this.value);
    },

    handleEditBlock(item) {
      adminService.editBlock(item.text, item.type, item.url, item.state, item.image, item.icons, item.block_id, item.position)
          .then((res) => {
            console.log(res);
            this.$emit(ITEM_CHANGE_EVENT, item);
          })
          .catch((err) => {
            if (err instanceof validateError) {
              const validate = err.getError();
              console.log(validate)
              if (validate.url) {
                this.urlErr = validate.url;
                this.hasUrlError = true
              }
              if (validate.text) {
                this.textErr = validate.text;
                this.hasTextError = true
              }
            }
            toast.show({
              content: err.message,
              stayTime: 3000,
              withMask: false
            })
          })
    },

    handleImgPopup(item) {
      return this.$emit(IMAGE_POPUP_EVENT, item);
    },

    handleUrlChange(text) {
      if (!text || text.length <= 0) {
        this.handleEditBlock(this.value);
        return;
      }
      const rule = /^(https|http|tel|mailto|wechat):\/\//i;
      if (rule.test(text)) {
        this.handleEditBlock(this.value);
        this.hasUrlError = false;
        this.urlErr = '';
      } else {
        this.hasUrlError = true
        this.urlErr = 'Invalid Link';
      }
    },

    handleChange() {
      this.handleEditBlock(this.value);
    }
  },
  watch:{
    'item': {
      deep: true,
      handler(val, oldVal) {
        this.value = val;
      }
    }
  }
}
</script>